import React, { useState, useEffect } from "react";
import CyberCareerSkills from "../components/Courses/CyberSecurity/CareerSkillsSection";
import CyberAdmissionRequ from "../components/Courses/CyberSecurity/CyberAdmissionReq";
import CyberSecurityHeader from "../components/Courses/CyberSecurity/CyberSecurityHeader";
import ProgramDuration from "../components/Courses/Shared/ProgramDuration";
import ProgramBenefits from "../components/Courses/Shared/ProgramBenefits";
import StudentAcceptanceForm from "../components/Courses/Shared/StudentAcceptanceForm";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import cmsApi from "../services/cmsApi";

const CYBER_SECURITY_BENEFITS = [
  "Massive Job Demand — With millions of cybersecurity positions unfilled globally and growing digital infrastructure in Tanzania, qualified graduates enter a job market where demand far exceeds supply.",
  "High Salaries and Career Growth — Cybersecurity is one of the highest-paying technology fields, with clear advancement pathways into roles like Security Analyst, Ethical Hacker, Incident Response Specialist, and Chief Information Security Officer (CISO).",
  "Hands-On, Practical Training — You will work through real-world attack and defense scenarios, learning the tools and techniques professionals use every day in the field.",
  "Protect What Matters — As individuals, businesses, and governments increasingly depend on digital systems, cybersecurity professionals play a critical role in keeping data, finances, and infrastructure safe.",
  "Diverse Specializations — The field covers network security, cloud security, digital forensics, ethical hacking, cyber law, and risk management — giving you a broad and valuable skill set.",
  "An Alert, Analytical Mindset — Beyond technical tools, this program trains you to think like an attacker in order to defend effectively — a mindset valuable across many industries and roles.",
];

const CYBER_SECURITY_CAREER_PATHS =
  "Graduates commonly go on to become Security Analysts, Ethical Hackers, Network Security Engineers, Digital Forensics Specialists, and IT Security Officers.";

const CyberSec = () => {
  const [pageComponents, setPageComponents] = useState({});
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);

  useEffect(() => {
    // Only fetch on client side to avoid hydration issues
    if (typeof window === 'undefined') return;

    const fetchPageData = async () => {
      try {
        setLoading(true);
        
        // Fetch all page components for Cyber Security page
        const result = await cmsApi.getPageComponents('cyber-security');
        
        if (result.success && result.components) {
          // Filter to only active components and organize by componentName
          const componentsMap = {};
          result.components
            .filter(comp => comp.isActive !== false) // Only show active components
            .forEach(comp => {
              componentsMap[comp.componentName] = comp;
            });
          setPageComponents(componentsMap);
        } else {
          console.warn('No page components found, using defaults');
        }
      } catch (error) {
        console.error('Error fetching Cyber Security page data:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  // Show loading state (optional)
  if (loading && typeof window !== 'undefined') {
    return (
      <div>
        <Navbar />
        <div className="mid-desktop-page">
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-custom-pink border-t-transparent mx-auto mb-4"></div>
            <p className="text-gray-600">Loading Cyber Security page...</p>
          </div>
        </div>
        </div>
        <Footer />
        <FloatingSocialPanels />
      </div>
    );
  }

  // Always render components - they have default content if CMS data is missing
  const headerComponent = pageComponents.header;
  const careerSkillsComponent = pageComponents['career-skills'];
  const admissionRequirementsComponent = pageComponents['admission-requirements'];

  return (
    <div>
      <Navbar />
      <div className="mid-desktop-page">
      {/* Hero Section - Always render with defaults if no CMS data */}
      <CyberSecurityHeader componentData={headerComponent} />
      {/* Career Skills Section - Always render with defaults if no CMS data */}
      <CyberCareerSkills componentData={careerSkillsComponent} />
      {/* Course Duration */}
      <ProgramDuration />
      {/* Why Choose Cyber Security at JRIIT? */}
      <ProgramBenefits
        programName="Cyber Security"
        benefits={CYBER_SECURITY_BENEFITS}
        careerPaths={CYBER_SECURITY_CAREER_PATHS}
      />
      {/* Admission Requirements Section - Always render with defaults if no CMS data */}
      <CyberAdmissionRequ componentData={admissionRequirementsComponent} />
      {/* Student Acceptance Form */}
      <StudentAcceptanceForm programName="Cyber Security" />
      <FullScreenImage />
      </div>
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default CyberSec;
